import { renderContentToSafeHtml, resolveContentDocument } from '@/app/richEdit/content'
import { MainContent } from '@/deskUiSkeletons/Page/MainContent'
import { PageBackdrop } from '@/msgComponents/PageBackdrop/PageBackdrop'
import { legacyContractAttrs, legacyHookAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { selectAccessState, selectMainState } from '@/msgdeskRuntime/state'
import { useSubsStore } from '@/state/MsgTreeProvider'

export function SitePage({ active }: { active: boolean }) {
  const { state } = useSubsStore()
  const main = selectMainState(state)
  const access = selectAccessState(state)
  const contentDoc = resolveContentDocument(main)
  // The main.iframe template contract carries the safe HTML STRING form of
  // the same document the ContentView renders (bridge selector address).
  const safeBodyHtml = contentDoc ? renderContentToSafeHtml(contentDoc) : ''

  return (
    <section
      {...legacyHookAttrs('workspace.main', `md-site-workspace md-site-workspace--main min-h-full w-full${active ? '' : ' hidden'}`)}
      style={{ display: active ? 'block' : 'none' }}
    >
      <div
        {...legacyHookAttrs('main.root', 'md-site-main min-h-full w-full')}
        style={{ display: active ? 'block' : 'none' }}
      >
        <div {...legacyHookAttrs('main.body', 'md-site-body min-h-full w-full')}>
          <template
            {...legacyContractAttrs('main.iframe')}
            dangerouslySetInnerHTML={{ __html: access.showUnlocked ? safeBodyHtml : '' }}
          />
          <PageBackdrop variant="paper" className="md-site-content p-3 sm:p-5">
            <MainContent
              frame={{ kind: 'page' }}
              className="min-h-screen w-full overflow-x-auto bg-white [&_img]:max-w-full"
            />
          </PageBackdrop>
        </div>
      </div>
    </section>
  )
}
